import type { FaireProductEntity } from "../../entity_types/product";

export const p_etqf7dmf7c: FaireProductEntity = {
  token: "p_etqf7dmf7c",
  type: "product",
  name: "DIAMOND COURT - Sculptural Thong Wedge, Classy Tie Up Straps",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/dff411dff4c538044326f81fde132659606c33fbfd7398ab605c38ba7d192a67.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e3301951e617956fe80c91571841e06bb3e80e41a987b41a50b28ede5335aeb.jpeg",
    "https://cdn.faire.com/fastly/f796c6b704862b5c6f70d85a42ee37b52e7d98b9517ca771e40cc52bb8357075.jpeg",
    "https://cdn.faire.com/fastly/894b77eef913d028fa0865e2c277db7206ce10a2a749b853929713745752666d.jpeg",
    "https://cdn.faire.com/fastly/6f622da3b2d9d89b2fb9e22f6547443bb1d6fbc6b1d3f4a9ab0f72cd14c5a601.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 16,
  description:
    "DIAMOND COURT is an architectural take on the classic thong sandal. This statement heel features a sculptural wedge silhouette balanced with delicate wrap ties at the ankle for a soft, feminine finish. Clean lines meet modern structure, making it the perfect blend of bold and wearable. Elevated yet effortless, this style brings an unexpected edge to warm-weather dressing.\n\nAvailable in Taupe and Chocolate.\n\n𝐎𝐎𝐓𝐃\nPair with a sleek slip dress or a midi skirt and cropped knit for a look that feels intentional but easy. For daytime, style with relaxed trousers and a tucked-in tee; for night, add a mini bag and slick hair to let the heel do the talking. Modern, confident, and just a little dramatic.",
  tags: [],
  msrpDollars: 35,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:15.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
